import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const MenusPage = lazy(() =>
  import("@/admin/pages/MenusPage").then((m) => ({ default: m.MenusPage })),
);

export const Route = createFileRoute("/admin/menus")({
  component: () => (
    <Suspense fallback={null}>
      <MenusPage />
    </Suspense>
  ),
});
